// export const LOGOUT_OK = state => {
//   state.user = {}
//   state.roles = null
//   state.loggedIn = false
// }

export const getEmployee = (state, res) => {
  state.employees = res
}

export const employeeForm = (state, val) => {
  let temp = []

  if (val.areas)
    val.areas.forEach(element => {
      temp.push(element.id)
    })

  val.area = temp

  state.employee = val
}

export const employeeFormReset = state => {
  state.employee = {
    name: '',
    email: '',
    password: '',
    phone: '',
    number: '',
    position_id: null,
    superordinate_id: null,
    area: [],
    role: null,
    division: null,
    group_principal_id: null
  }
}

export const getPositions = (state, val) => {
  state.positions = val
}

export const getListPosition = (state, res) => {
  state.listPosition = res
}

export const positionForm = (state, val) => {
  state.position = val
}

export const employeeTableSort = (state, val) => {
  state.employeeTableSort = val
}

export const getDivisions = (state, val) => {
  state.divisions = val
}

export const divisionForm = (state, val) => {
  state.division = val
}

export const divisionFormReset = state => {
  state.division = {
    name: ''
  }
}
